import React, { PropTypes } from 'react';
import InputGroup from '../InputGroup';
import BaseField from './Base';


export default class Select extends BaseField {
  static propTypes = {
    label: PropTypes.string.isRequired,
    group: PropTypes.shape({}),
    options: PropTypes.array.isRequired,
    placeholder: PropTypes.string
  };

  render() {
    const { id } = this.state;
    const {
      group,
      options,
      label,
      input,
      placeholder,
      meta: { touched, error, invalid }
    } = this.props;
    return (
      <InputGroup id={id} invalid={touched && invalid} label={label} {...group}>
        <select {...input} id={id} className="form-control">
          {placeholder && <option value="" hidden disabled>{placeholder}</option>}
          {options.map(({id, label}) => 
            <option key={id} value={id}>{label}</option>
          )}
        </select>
        { (touched && error) && <div className="form-control-feedback">{error}</div> }
      </InputGroup>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Form/Field/Select.js